<template>
    <v-container style="background-color: var(--v-extraLightGrey-base); width:100%" class="px-0 pt-0 pb-2">
        <v-sheet dense v-for="(item,i) in rules" :key="i" color="extraLightGrey" style="width:100%">
            <v-sheet class="d-flex flex-row flex-nowrap" style="background-color: var(--v-extraLightGrey-base);">
                <v-row dense class="mx-0">
                    <v-col :cols="getCols(item)"  class="d-flex align-center">
                        <span class="mr-2 pr-4 text--primary"><translation-container :context="this" value="If"></translation-container></span>
                        <v-select outlined dense
                                :label="Translate('Operator')"
                                :items="condition_types"
                                item-text="text"
                                item-value="value"
                                :menu-props="{ offsetY: true }"
                                v-model="item.operator"
                                @change="thresholdChanged"
                                background-color="white"
                                hide-details
                                :rules="operatorRules"
                                :error-messages="operatorErrorMessages"
                                :error="operatorErrorMessages.length > 0"></v-select>
                    </v-col>

                    <v-col cols="4" v-if="item.operator != 'missing' && item.operator != 'inRange' && item.operator != 'notInRange'" class="d-flex align-center">
                        <v-text-field type="number" :label="Translate('Value')"
                                    outlined dense :placeholder="placeholder"
                                    v-model.number="item.value"
                                    @input="thresholdChanged"
                                    background-color="white"
                                    hide-details
                                    :rules="valueRules"
                                    :error-messages="valueErrorMessages"
                                    :error="valueErrorMessages.length > 0">
                            <template v-slot:append>
                                <span class="mt-1">{{ units }}</span>
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="2" v-if="item.operator == 'inRange' || item.operator == 'notInRange'"  class="d-flex align-center">
                        <v-text-field type="number" :label="Translate('From')"
                                    outlined dense :placeholder="placeholder"
                                    v-model.number="item.value"
                                    @input="thresholdChanged"
                                    background-color="white"
                                    hide-details
                                    :rules="valueFromRules"
                                    :error-messages="fromErrorMessages"
                                    :error="fromErrorMessages.length > 0" >
                            <template v-slot:append>
                                <span class="mt-1">{{ units }}</span>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="2" v-if="item.operator == 'inRange' || item.operator == 'notInRange'"  class="d-flex align-center">
                        <v-text-field type="number" :label="Translate('To')"
                                    outlined dense :placeholder="placeholder"
                                    v-model.number="item.valueTo"
                                    @input="thresholdChanged"
                                    background-color="white"
                                    hide-details
                                    :rules="valueToRules"
                                    :error-messages="valueToErrorMessages"
                                    :error="valueToErrorMessages.length > 0" >
                            <template v-slot:append>
                                <span class="mt-1">{{ units }}</span>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="4" class="d-flex align-center">        
                        <span class="mx-2 text--primary"><translation-container :context="this" value="then"></translation-container></span>
                        <ThresholdformatOptions :EventBus="EventBus" :defaultColor="value.color" @thresholdFormatChanged="thresholdFormatChanged"/>
                    </v-col>
                </v-row>
                <!-- <v-btn icon class="mr-n9" v-if="i > 0" @click="removeOperator()">
                    <v-icon>mdi-window-close</v-icon>
                </v-btn>-->
            </v-sheet>
              <!--  <v-row v-if="i < 1" v-show="rules.length > 1" justify="center">
                    <v-radio-group :value="item.combiner" @change="(value) => setItemCombiner(item, i, value)"  mandatory row class="mt-6 mb-1 ml-1">
                        <v-radio label="AND" value="AND">
                        </v-radio>
                        <v-radio label="OR" value="OR">
                        </v-radio>
                    </v-radio-group>
                </v-row> -->
        </v-sheet>
        <!-- Commenting this out, unless we want to support AND/OR -->
       <!-- <v-hover >
            <v-btn v-show="rules.length == 1" elevation="0" class="px-0 customHoverButton" @click="addOperator()">
                <v-icon left class="mr-1">
                    mdi-plus
                </v-icon>
                Add Rule
            </v-btn>
        </v-hover>-->
    </v-container>
</template>

<script>
    import { appSettings } from '@/Shared/appSettings';
    import methods from '@/Shared/methods';

    import _ from 'lodash';
    import Vue from 'vue';

    import ThresholdformatOptions from './threshold_formatOptions.vue';

    const getCurrencySymbol = (locale, currency) => (0).toLocaleString(locale, { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\d/g, '').trim();

    export default {
        components: {
            ThresholdformatOptions
        },
        data: function () {
            return {
                rules: [{ operator: 'greaterThan', value: '', valueTo: '', combiner: undefined }],
                operatorErrorMessages: [],
                valueErrorMessages: [],
                valueToErrorMessages: [],
                fromErrorMessages: []
            }
        },
        props: {
            item: Object,
            aggregateFunction: null,
            value: null,
            isAggregateReport: false,
            EventBus: null
        },
        created() {
            if (this.value)
            {
                console.log(`threshold_durationColumn has received an initialValue of ${JSON.stringify(this.value)}`);
            }
            // For percent: multiply by 100 for display; round to avoid float noise (e.g. 0.571 -> 57.1 not 57.10000000000001)
            const fromPercentDisplay = (v) => (v === '' || v == null) ? v : Math.round(Number(v) * 10000) / 100;
            const isPercent = this.actualColumnType() == 'percentColumn';
            this.rules[0].value = isPercent ? fromPercentDisplay(this.value.value) : this.value.value;
            this.rules[0].operator = this.value.operator;
            this.rules[0].valueTo = isPercent ? fromPercentDisplay(this.value.valueTo) : this.value.valueTo;

           

            if (this.value && this.value.type) {
                this.rules = [{
                    operator: this.value.operator,
                    value: isPercent ? fromPercentDisplay(this.value.value) : this.value.value,
                    valueTo: isPercent ? fromPercentDisplay(this.value.valueTo) : this.value.valueTo,
                }];
            }
            else if (this.value && this.value.conditions && this.value.conditions.length == 2) {
                this.rules = [{
                    operator: this.value.operator,
                    value: isPercent ? fromPercentDisplay(this.value.conditions[0].value) : this.value.conditions[0].value,
                    valueTo: isPercent ? fromPercentDisplay(this.value.conditions[0].valueTo) : this.value.conditions[0].valueTo,
                    combiner: this.value.operator,
                },{
                    operator: this.value.operator,
                    value: isPercent ? fromPercentDisplay(this.value.conditions[1].value) : this.value.conditions[1].value,
                    valueTo: isPercent ? fromPercentDisplay(this.value.conditions[1].valueTo) : this.value.conditions[1].valueTo,
                }];
            }
        },
        watch: {
            rules: function (newv) {
                if (newv.every(a => a.value !== ''))
                    this.thresholdChanged();
            },
            'item.operator': () => this.triggerValidation(),
            'item.value': () => this.triggerValidation()
        },
        computed: {
            condition_types: function() {
                return [
                    { text: this.Translate('Greater Than'), value: 'greaterThan' },
                    { text: this.Translate('Greater Than or Equal To'), value: 'greaterThanOrEqualTo' },
                    { text: this.Translate('Less Than'), value: 'lessThan' },
                    { text: this.Translate('Less Than or Equal To'), value: 'lessThanOrEqualTo' },
                    { text: this.Translate('Equals'), value: 'equals' },
                    { text: this.Translate('Does Not Equal'), value: 'notEquals' },
                    { text: this.Translate('Between'), value: 'inRange' },
                    { text: this.Translate('Not Between'), value: 'notInRange' },
                    { text: this.Translate('Missing'), value: 'missing' },
                ];
            },
            units: function() {
                console.log("Trying to figure out computed.units.  this.item is " + JSON.stringify(this.item));
                return this.actualColumnType() == 'durationColumn' ? 'sec' :
                    this.actualColumnType() == 'percentColumn' ? '%' :
                        this.actualColumnType() == 'currencyColumn' ? getCurrencySymbol(appSettings.LocaleKey, appSettings.Currency || 'USD') :
                            '#';
            },
            placeholder: function () {
                return this.actualColumnType() == 'durationColumn' ? this.Translate('Enter value in seconds') :
                    this.actualColumnType() == 'percentColumn' ? this.Translate('Enter percentage value') :
                        this.actualColumnType() == 'currencyColumn' ? this.Translate('Enter currency value') :
                            this.Translate('Enter value');
            },
            operatorRules() {
                return [
                    v => !!v || this.Translate('Please select an operator')
                ];
            },
            valueRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please enter a value')
                ];
            },
            valueToRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please enter a value')
                ];
            },
            valueFromRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please enter a value')
                ];
            },
        },
        methods: {
            ...methods,
            getCols: function(item) {
                    const currentOperator = item.operator;
                    if (currentOperator === 'missing') {
                        return 8; // Take up more space when 'missing'
                    }
                    return 4; // Default size for other operators
            },
            actualColumnType() {
                if (this.isAggregateReport)
                {
                    if (this.item.MetricAggs.Type == "bucket_script" && this.item.MetricAggs.BucketScript.ResultType){
                        return this.item.MetricAggs.BucketScript.ResultType;
                    }

                    if (this.aggregateFunction ==  "max")
                    {
                        return this.item.SourceType;
                    }
                    if (this.aggregateFunction == "cardinality")
                    {
                       if (this.item && this.item.MetricAggs && this.item.MetricAggs.BucketScript && this.item.MetricAggs.BucketScript.ResultType)
                        {   
                            return this.item.MetricAggs.BucketScript.ResultType;
                        }
                    }
                }

                return this.item.SourceType;
            },            
            thresholdFormatChanged(message){
                this.$emit('thresholdFormatChanged', message);
            },
            thresholdChanged() {
                var ruleType = this.actualColumnType() == 'durationColumn' ? 'duration' :
                this.actualColumnType() == 'percentColumn' ? 'percent' :
                    this.actualColumnType() == 'currencyColumn' ? 'currency' :
                        'number';


                if (this.rules[0].operator == 'missing')
                {
                    this.rules[0].value = "";
                    this.rules[0].valueTo = "";
                }
                // Single rule scenario is the simplest format (made popular by ag-grid)
                let firstRule = this.rules[0];
                // For percent: divide by 100 then round to avoid float precision (e.g. 57.1 -> 0.571 not 0.5710000000000001)
                const toPercentDecimal = (v) => (v === '' || v == null) ? v : Math.round(Number(v) * 10000) / 10000;
                const percentValue = this.actualColumnType() == 'percentColumn';
                this.$emit('thresholdValuesChanged', {
                    thresholdtype: "number",
                    operator: firstRule.operator,
                    value: percentValue ? toPercentDecimal(firstRule.value / 100) : firstRule.value,
                    valueTo: percentValue ? toPercentDecimal(firstRule.valueTo / 100) : firstRule.valueTo,
                    type: ruleType
                });
            },
            setItemCombiner(item, index, value) {
                console.log(`setItemCombiner[${index}] to ${value}:`);
                item.combiner = value;
                this.thresholdChanged();
            },
            addOperator() {
                this.rules.push({ operator: 'greaterThan', value: 0, valueTo: 0, combiner: undefined });
            },
            removeOperator() {
                this.rules.pop();
            },
            triggerValidation() {
                this.operatorErrorMessages = [];
                this.valueErrorMessages = [];
                this.valueToErrorMessages = [];
                this.fromErrorMessages = [];

                for (const rule of this.operatorRules) {
                    const result = rule(this.item.operator);
                    if (typeof result === 'string') {
                        this.operatorErrorMessages.push(result);
                        break; // Stop at the first error
                    }
                }

                if(this.item.operator != 'missing' && this.item.operator != 'inRange' && this.item.operator != 'notInRange'){
                    for (const rule of this.valueRules) {
                        const result = rule(this.item.value);
                        if (typeof result === 'string') {
                            this.valueErrorMessages.push(result);
                            break; // Stop at the first error
                        }
                    }
                }

                if(this.item.operator == 'inRange' || this.item.operator == 'notInRange'){
                    for (const rule of this.valueFromRules) {
                        const result = rule(this.item.value);
                        if (typeof result === 'string') {
                            this.fromErrorMessages.push(result);
                            break; // Stop at the first error
                        }
                    }

                    for (const rule of this.valueToRules) {
                        const result = rule(this.item.valueTo);
                        if (typeof result === 'string') {
                            this.valueToErrorMessages.push(result);
                            break; // Stop at the first error
                        }
                    }
                }
                                
            },
        }
    }
</script>

<style scoped>
    .verydense {
        max-height: 24px;
        min-height: 24px;
    }

    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }
    .customHoverButton:before {
        background-color: unset !important;
        transition: unset !important;
    }
    .customHoverButton {
        background-color:unset !important;
        color: var(--v-primary-base);
    }
    .customHoverButton:hover {
        filter: brightness(80%);
    }

</style>